module.exports = __webpack_public_path__ + "img/instagram.4c1441d0.svg";